import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { Rectangle } from 'pixi.js';
import { AnimationContents } from '../../../../AnimationContents';
import { EngineLogic } from '../../../Logic/MiniGames/EngineLogic';
import { EnginePowerUpModel } from '../../../Models/MiniGames/PowerEnigineUpModel';
import { EngineBackgroundController } from './EngineBackgroundController';
import { EngineButtonController, engineButtons } from './EngineButtonController';
import { GameLogic } from '../../../Logic/GameLogic';
import { DialogTextEnum, DialogTypeTextEnum } from '../../../Models/GameModel';
import { SoundConstants } from '../../../Constants/SoundConstants';
import { SoundType } from '@denishussar/html5-game-engine';
import { ButtonController } from '../../../Common/ButtonController';
export interface IEngineGameControllerOptions {
    onComplete: () => void;
}

export class EngineGameController extends AnimationBaseController {
    public $model: EnginePowerUpModel;
    private _width: number;
    private _height: number;
    public constructor(
        @Inject private _options: IEngineGameControllerOptions,
        @Inject private _engineLogic: EngineLogic,
        @Inject private _gameLogic: GameLogic
    ){
        super('EnigneGameController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.ENGINE_GAME_SCREEN_JSON,
            libraryName: 'mini_game_engine',
            sounds: [
                {
                    id: SoundConstants.MINIGAME_ERROR,
                    type: SoundType.SFX
                },
            ],
            childControllers: {
                btnContur1: {
                    instanceName: 'contur1',
                    controller: EngineButtonController,
                    options: {
                        btn : engineButtons.contur1,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.contur1);
                        },
                    },
                    model: this.$model,
                },
                btnContur2: {
                    instanceName: 'contur2',
                    controller: EngineButtonController,
                    options: {
                        btn : engineButtons.contur2,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.contur2);
                        },
                    },
                    model: this.$model,
                },
                btnReactor1: {
                    instanceName: 'reactor1',
                    controller: EngineButtonController,
                    options: {
                        btn : engineButtons.reactor1,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.reactor1);
                        },
                    },
                    model: this.$model,
                },
                btnReactor2: {
                    instanceName: 'reactor2',
                    controller: EngineButtonController,
                    options: {
                        btn : engineButtons.reactor2,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.reactor2);
                        },
                    },
                    model: this.$model,
                },
                btnPowerUp: {
                    instanceName: 'btn_start',
                    controller: EngineButtonController,
                    options: {
                        btn: engineButtons.powerUp,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.powerUp);
                            setTimeout(()=>{
                                if(this.$model.btnStates[engineButtons.powerUp]) {
                                    this._options.onComplete();
                                    this._gameLogic.showDialogScreen(DialogTextEnum.engine, DialogTypeTextEnum.end);
                                }
                            }, 200);
                        },
                    },
                    model: this.$model,
                },
                sliderTurbine: {
                    instanceName: 'turbine_slider',
                    controller: EngineButtonController,
                    options: {
                        btn: engineButtons.turbine,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.turbine);
                        },
                    },
                    model: this.$model,
                },
                sliderGenerator: {
                    instanceName: 'generator_slider',
                    controller: EngineButtonController,
                    options: {
                        btn: engineButtons.generator,
                        onClick: ()=>{
                            this._engineLogic.buttonsClick(engineButtons.generator);
                        },
                    },
                    model: this.$model,
                },
            },
        }
    }
    onInitialize(): void {
        this._width = 1920;
        this._height = 1440;

        const reactorX = (413)/2;
        const reactorY = (278)/2;
        const conturX = (349)/2;
        const conturY = (237)/2;

        this.getDisplayObjectByQuery('reactor1')[0].hitArea = new Rectangle(-reactorX, -reactorY, reactorX*2, reactorY*2 );
        this.getDisplayObjectByQuery('reactor2')[0].hitArea = new Rectangle(-reactorX, -reactorY, reactorX*2, reactorY*2 );
        this.getDisplayObjectByQuery('contur1')[0].hitArea = new Rectangle(-conturX, -conturY, conturX*2, conturY*2 );
        this.getDisplayObjectByQuery('contur2')[0].hitArea = new Rectangle(-conturX, -conturY, conturX*2, conturY*2 );

        this._engineLogic.buttonsClick(engineButtons.dialog);

        this._gameLogic.showDialogScreen(DialogTextEnum.engine, DialogTypeTextEnum.start);
    }

    protected onResize(width: number, height: number, scale: number) {
        
        
        const scaleValue = Math.min(
            width / scale / this._width,
            height / scale / this._height,
        );

        this.scaleX = scaleValue;
        this.scaleY = scaleValue;
    }

}
